import './Services.css'

import { Link } from 'react-router-dom'
import { FaArrowRight, FaHome } from 'react-icons/fa'
const Services = () => {
  return (
    <div className="services container" id='services'>
      <div className="ourServices">Our Services</div>
      <h1>Our Main Focus</h1>
      <div className="serv-card">

        <div className="box" data-aos="flip-left" data-aos-duration='1000' data-aos-delay='200'>
          <div className="animate">
            <div className="serv-item">
              <i><FaHome /></i>
              <div className="serv-title">Buy a home</div>
              <div className="serv-content">over 1 million+ homes for sale available on the website, we can match you with a house you will want to call home.</div>
              <Link to='/list' className="serv-search">Find A Home <i><FaArrowRight /></i></Link>
            </div>
          </div>
        </div>


        <div className="box" data-aos="flip-up" data-aos-duration='1000' data-aos-delay='500'>
          <div className="animate">
            <div className="serv-item">
              <i><FaHome /></i>
              <div className="serv-title">Rental a home</div>
              <div className="serv-content">over 1 million+ homes for sale available on the website, we can match you with a house you will want to call home.</div>
              <Link to='/list' className="serv-search">Find A Home <i><FaArrowRight /></i></Link>
            </div>
          </div>
        </div>


        <div className="box" data-aos="flip-left" data-aos-duration='1000' data-aos-delay='200'>
          <div className="animate">
            <div className="serv-item">
              <i><FaHome /></i>
              <div className="serv-title">Mortgage a home</div>
              <div className="serv-content">over 1 million+ homes for sale available on the website, we can match you with a house you will want to call home.</div>
              <Link to='/list' className="serv-search">Find A Home <i><FaArrowRight /></i></Link>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Services